(function () {
    const init = function (root) {
        const control = root.querySelector('.imageRelatedArtists__visibilityControl');
        const list = root.querySelector('.imageRelatedArtists__list');
        control.addEventListener('click', () => {
            list.classList.toggle('imageRelatedArtists__list--visible');
            control.classList.toggle('imageRelatedArtists__visibilityControl--open');
        });

        const setImage = () => {
            const url = !!window.location.hash ? decodeURIComponent(window.location.hash.substr(1)) : '';
            const image = document.querySelector('[data-photo-viewer-image="' + url + '"][data-image-related-artists]');

            control.style.display = 'none';
            root.style.display = 'none';

            if (!!url && !!image) {
                const attr = image.getAttribute('data-image-related-artists');
                if (!!attr) {
                    const selected = attr.split(',');
                    if (selected.length > 0) {
                        const options = root.querySelectorAll('.imageRelatedArtists__card');
                        for (let i = 0; i < options.length; i++) {
                            const o = options[i];
                            o.style.display = selected.indexOf(o.getAttribute('data-value')) === -1 ? 'none' : 'flex';
                        }
                        root.style.display = 'block';
                        control.style.display = 'block';
                    }
                }
            }
        };

        window.addEventListener('hashchange', setImage);
        setImage();
    };
    window.addEventListener('load', ()=>{
        document.querySelectorAll('.imageRelatedArtists__root').forEach(init);
    });

}());

